<template>
  <div>
    <div class="page-header d-flex justify-content-between align-items-end">
      <div>
        <div class="d-flex">
          科目名：&emsp;<span class="fw-lighter">{{ suject }}</span>
        </div>
        <div v-if="isHidden2" class="d-flex">
          学習項目：<span class="fw-lighter">{{ project }}</span>
        </div>
        <div v-if="isHidden3" class="d-flex">
          教材：&emsp;&emsp;<span class="fw-lighter">{{ material }}</span>
        </div>
      </div>
      <div>
        <span v-show="isShow" class="fw-lighter">プレビュー</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    suject: String,
    project: String,
    material: String,
    isShow: Boolean,
    isHidden2: Boolean,
    isHidden3: Boolean
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped></style>
